var FaceTecStrings = {
  "FaceTec_action_ok": "ACEPTAR",
  "FaceTec_action_im_ready": "ESTOY LISTO",
  "FaceTec_action_try_again": "VOLVER A INTENTARLO",
  "FaceTec_action_continue": "CONTINUAR",
  "FaceTec_action_take_photo": "TOMAR FOTO",
  "FaceTec_action_accept_photo": "ACEPTAR",
  "FaceTec_action_retake_photo": "VOLVER",
  "FaceTec_action_confirm": "CONFIRMAR INFORMACIÓN",

  "FaceTec_accessibility_cancel_button": "Cancelar",
  "FaceTec_accessibility_tap_guidance": "Toque dos veces cualquier parte de la pantalla para ver indicaciones sobre cómo alinear el rostro.",
  "FaceTec_accessibility_key_down_guidance": "Presione Entrar o la barra espaciadora para obtener orientación sobre la alineación de la cara",

  "FaceTec_accessibility_feedback_move_phone_away": "Su rostro está demasiado cerca",
  "FaceTec_accessibility_feedback_move_phone_closer": "Su rostro está demasiado lejos",
  "FaceTec_accessibility_feedback_face_too_far_left": "Su rostro está demasiado a la izquierda",
  "FaceTec_accessibility_feedback_face_too_far_right": "Su rostro está demasiado a la derecha",
  "FaceTec_accessibility_feedback_face_too_low": "Su rostro está demasiado abajo",
  "FaceTec_accessibility_feedback_face_too_high": "Su rostro está demasiado arriba",
  "FaceTec_accessibility_feedback_face_rotated_too_far_left": "Su rostro gira demasiado a la izquierda",
  "FaceTec_accessibility_feedback_face_rotated_too_far_right": "Su rostro gira demasiado a la derecha",
  "FaceTec_accessibility_feedback_face_looking_too_far_left": "Su rostro está demasiado inclinado hacia la izquierda",
  "FaceTec_accessibility_feedback_face_looking_too_far_right": "Su rostro está demasiado inclinado hacia la derecha",
  "FaceTec_accessibility_feedback_face_not_in_camera": "El rostro no se ve en la cámara o está demasiado lejos",
  "FaceTec_accessibility_feedback_hold_phone_to_eye_level": "Mantenga el dispositivo a la altura de los ojos",
  "FaceTec_accessibility_feedback_move_away_web": "Cámara demasiado cerca",
  "FaceTec_accessibility_feedback_move_closer_web": "Cámara demasiado lejos",
  "FaceTec_accessibility_feedback_hold_to_eye_level_web": "Mover la cámara al nivel de los ojos",

  "FaceTec_presession_frame_your_face": "Encuadre su rostro en el óvalo",
  "FaceTec_presession_look_straight_ahead": "Mire hacia el frente",
  "FaceTec_presession_hold_steady3": "Manténgase quieto durante: 3",
  "FaceTec_presession_hold_steady2": "Manténgase quieto durante: 2",
  "FaceTec_presession_hold_steady1": "Manténgase quieto durante: 1",
  "FaceTec_presession_eyes_straight_ahead": "Mire hacia el frente",
  "FaceTec_presession_remove_dark_glasses": "Quítese los lentes oscuros",
  "FaceTec_presession_neutral_expression": "Expresión neutra, sin sonreír",
  "FaceTec_presession_conditions_too_bright": "Demasiada luz",
  "FaceTec_presession_brighten_your_environment": "Ilumine su entorno",

  "FaceTec_feedback_center_face": "Centre su rostro",
  "FaceTec_feedback_face_not_found": "Encuadre su rostro",
  "FaceTec_feedback_move_phone_away": "Apártese",
  "FaceTec_feedback_move_away_web": "Apártese",
  "FaceTec_feedback_move_phone_closer": "Acérquese",
  "FaceTec_feedback_move_web_closer": "Acerca la cara y rellena el óvalo",
  "FaceTec_feedback_move_web_even_closer": "Aún Más Cerca",
  "FaceTec_feedback_move_phone_to_eye_level": "Coloque la cámara a la altura de los ojos",
  "FaceTec_feedback_move_to_eye_level_web": "Mira Directamente A La Cámara",
  "FaceTec_feedback_face_not_looking_straight_ahead": "Mire hacia el frente",
  "FaceTec_feedback_face_not_upright": "Mantenga la cabeza recta",
  "FaceTec_feedback_face_not_upright_mobile": "Mantenga la cabeza recta",
  "FaceTec_feedback_hold_steady": "Quédese quieto",
  "FaceTec_feedback_use_even_lighting": "Ilumine el rostro de forma más uniforme",

  "FaceTec_instructions_header_ready_desktop": "Prepárese para su videoselfie",
  "FaceTec_instructions_header_ready_1_mobile": "Prepárese para",
  "FaceTec_instructions_header_ready_2_mobile": "su videoselfie",
  "FaceTec_instructions_message_ready_desktop": "Encuadre su rostro en el óvalo, Presione \"Estoy listo\" y acérquese",
  "FaceTec_instructions_message_ready_1_mobile": "Encuadre su rostro en el óvalo",
  "FaceTec_instructions_message_ready_2_mobile": "Presione \"Estoy listo\" y acérquese",

  "FaceTec_retry_header": "Intentémoslo otra vez",
  "FaceTec_retry_subheader_message": "Necesitamos una videoselfie más nítida",
  "FaceTec_retry_your_image_label": "Su selfie",
  "FaceTec_retry_ideal_image_label": "Pose ideal",
  "FaceTec_retry_instruction_message_1": "Use una postura e iluminación ideal",
  "FaceTec_retry_instruction_message_2": "Expresión neutra, sin sonreír",
  "FaceTec_retry_instruction_message_3": "Demasiado borrosa, limpie la cámara",

  "FaceTec_camera_feed_issue_header": "Problema al proteger la conexión de la cámara",
  "FaceTec_camera_feed_issue_header_mobile": "Problema al proteger<br/>la conexión de la cámara",
  "FaceTec_camera_feed_issue_subheader_message_mobile": "Esta aplicación bloquea configuraciones de cámara web sospechosas.<br/><a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; font:inherit; pointer-events:all;'>Aprende más aquí.</a>.",
  "FaceTec_camera_feed_issue_subheader_message": "Este sistema no se puede verificar debido a lo siguiente:",
  "FaceTec_camera_feed_issue_table_header_1": "Posible Problema",
  "FaceTec_camera_feed_issue_table_header_2": "Corregir",
  "FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error": "Permisos de cámara no recordados en Firefox.",
  "FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error": "Marque Recordar Permisos.",
  "FaceTec_camera_feed_issue_table_row_1_cell_1": "Cámara ya en uso por otra aplicación.",
  "FaceTec_camera_feed_issue_table_row_1_cell_2": "Cierra la otra aplicación.",
  "FaceTec_camera_feed_issue_table_row_2_cell_1": "Una aplicación 3rd-Party está modificando el video.",
  "FaceTec_camera_feed_issue_table_row_2_cell_2": "Cierre / desinstale la otra aplicación.",
  "FaceTec_camera_feed_issue_table_row_3_cell_1": "Equipos que no pueden ser protegidos.",
  "FaceTec_camera_feed_issue_table_row_3_cell_2": "Usa un dispositivo diferente.",
  "FaceTec_camera_feed_issue_subtable_message": "Esta aplicación bloquea configuraciones de cámara web sospechosas. <a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline; font:inherit; pointer-events:all;'>Aprende más aquí.</a>.",
  "FaceTec_camera_feed_issue_action": "VOLVER A INTENTARLO",
  "FaceTec_camera_feed_issue_action_firefox_permissions_error": "ACEPTAR",

  "FaceTec_camera_permission_header": "Habilite la cámara",
  "FaceTec_camera_permission_message": "Permisos de cámara deshabilitados.<br/>Verifique la configuración de su sistema operativo y navegador",

  "FaceTec_enter_fullscreen_header": "Modo Selfie a Pantalla Completa",
  "FaceTec_enter_fullscreen_message": "Antes de comenzar, haga clic en el botón de abajo para abrir el modo de pantalla completa.",
  "FaceTec_enter_fullscreen_action": "ABRIR PANTALLA COMPLETA",

  "FaceTec_initializing_camera": "Protegiendo la conexión",

  "FaceTec_idscan_type_selection_header": "Prepárese para escanear<br/>su identificación",
  "FaceTec_idscan_capture_id_front_instruction_message": "Anverso de su identificación",
  "FaceTec_idscan_capture_id_back_instruction_message": "Reverso de su identificación",
  "FaceTec_idscan_review_id_front_instruction_message": "Verifique sea nítida y legible",
  "FaceTec_idscan_review_id_back_instruction_message": "Verifique sea nítida y legible",
  "FaceTec_idscan_additional_review_message": "Se requiere<br/>una verificación adicional",
  "FaceTec_idscan_ocr_confirmation_main_header": "Revisar y confirmar",
  "FaceTec_idscan_ocr_confirmation_scroll_message": "Desplácese hacia abajo",
  "FaceTec_idscan_feedback_flip_id_to_back_message": "Reverso de su identificación",

  "FaceTec_result_success_message": "Listo",
  "FaceTec_result_facescan_upload_message": "Subiendo<br/>el escaneo facial 3D<br/>encriptado",
  "FaceTec_result_idscan_upload_message": "Subiendo<br/>el escaneo de identificación<br/>encriptado",
  "FaceTec_result_idscan_unsuccess_message": "La foto de la identificación<br/>o coincide con\el rostro del usuario",
  "FaceTec_result_idscan_success_front_side_message": "Escaneo de identificación completado",
  "FaceTec_result_idscan_success_front_side_back_next_message": "Anverso de la identificación<br/>escaneado",
  "FaceTec_result_idscan_success_back_side_message": "Escaneo de identificación completado",
  "FaceTec_result_idscan_success_passport_message": "Escaneo de pasaporte completado",
  "FaceTec_result_idscan_success_user_confirmation_message": "Escaneo de identificación con fotografía<br/>completado",
  "FaceTec_result_idscan_success_additional_review_message": "Captura de la fotografía de identificación<br/>completada",
  "FaceTec_result_idscan_retry_face_did_not_match_message": "El rostro no coincide<br/>lo suficiente",
  "FaceTec_result_idscan_retry_id_not_fully_visible_message": "La identificación<br/>no es totalmente visible",
  "FaceTec_result_idscan_retry_ocr_results_not_good_enough_message": "El texto de la identificación no es legible",
  "FaceTec_result_idscan_retry_id_type_not_suppported_message": "No se admite este tipo de identificación<br/>Utilice una identificación diferente",
  "FaceTec_result_idscan_retry_barcode_not_read_message": "No se pudo escanear el código de barras<br/>Inténtelo de nuevo",
};

module.exports = FaceTecStrings;
